/**
 * Pastiglia con l'estensione del file, colorata per famiglia.
 *
 * Sta in un componente suo perché la usano sia l'elenco di una cartella sia i
 * risultati di ricerca: la mappa estensione -> colore deve avere un posto solo,
 * altrimenti un PDF finisce rosso in una vista e grigio nell'altra.
 */
import { FOLDER_PATH } from './FolderGlyph.jsx';
import './FileChip.css';

/** Famiglie di estensioni che meritano un colore proprio. */
const EXT_FAMILY: Record<string, string> = {
  pdf: 'pdf',
  p7m: 'firma',
  xml: 'dati',
  csv: 'dati',
  xlsx: 'foglio',
  xls: 'foglio',
  docx: 'testo',
  doc: 'testo',
  txt: 'testo',
  jpg: 'img',
  jpeg: 'img',
  png: 'img',
  zip: 'zip',
};

/** Estensione in minuscolo, o stringa vuota per un nome che non ne ha. */
export function extensionOf(name: string): string {
  const ext = name.split('.').pop()?.toLowerCase() ?? '';
  return ext === name.toLowerCase() ? '' : ext;
}

export function FileChip({ name }: { name: string }) {
  const ext = extensionOf(name);
  return (
    <span className={`chip chip--${EXT_FAMILY[ext] ?? 'altro'}`}>
      {ext ? ext.toUpperCase().slice(0, 4) : '—'}
    </span>
  );
}

/** Variante cartella: stessa forma della pastiglia, così le righe restano allineate. */
export function FolderChip() {
  return (
    <span className="chip chip--cartella" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="14" height="14" fill="none">
        <path
          d={FOLDER_PATH}
          stroke="currentColor"
          strokeWidth="1.6"
        />
      </svg>
    </span>
  );
}
